<script>
import OmniOmniTextarea from "@/components/omni/OmniTextarea.vue";

export default {
  name: "OrderViewNote",
  components: { OmniTextarea: OmniOmniTextarea },
  props: {
    order: Object,
  },
};
</script>

<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col>
          <omni-textarea
            :model-value="order.generalNote"
            data-qa="general-note"
            label="General note"
            readonly
            rows="4"
            variant="filled"
          >
          </omni-textarea>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped></style>
